export const SUPPLY_WINDOW_DAYS = [3, 5, 9] as const

export type SupplyWindowDays = (typeof SUPPLY_WINDOW_DAYS)[number]

export type SupplyEventKind = 'delivery' | 'production_order' | 'stockout' | 'breakage'

export type SupplyStockoutCause = 'defective_stock' | 'depleted'

export interface SupplyHourPoint {
  t: string
  stock: number | null
  sales: number | null
  correctedSales: number | null
  forecastSales: number
  forecastStock: number | null
}

export interface SupplyEventProduct {
  label: string
  count: number
}

export interface SupplyEvent {
  t: string
  kind: SupplyEventKind
  count: number
  id: string
  rate?: number | null
  fifoScore?: number | null
  cause?: SupplyStockoutCause
  products?: SupplyEventProduct[]
}

export interface SupplyKpis {
  vpj: number
  vph: number
  sales: number
  gapPercent: number
  gapUnits: number
  forecastElapsed: number
  correctedSales: number
  stock: number
  expectedLanding: number
  expectedLandingPercent: number
  breakageRate: number
  breakageCount: number
  forecastBreakageCount: number
  forecastBreakageRate: number
  stockoutCount: number
  stockoutRate: number
  forecastStockoutCount: number
  forecastStockoutRate: number
}

export interface SupplyCategoryRow {
  categoryId: number
  label: string
  kpis: SupplyKpis
  correctionPercent: number
}

export interface SupplyArticleRow {
  productId: number
  label: string
  kpis: SupplyKpis
  correctionPercent: number
}

export interface SupplyTimelineResponse {
  window: { start: string; end: string; now: string }
  hours: SupplyHourPoint[]
  events: SupplyEvent[]
  kpis: SupplyKpis
  categories: SupplyCategoryRow[]
  articles: SupplyArticleRow[]
  undatedArticles: number
  growthNeutralized: boolean
}

export interface SupplyTimelineParams {
  /** `null` reads the network view: the sum of every active boutique. */
  storeId: number | null
  days: SupplyWindowDays
  scope?: 'category' | 'product'
  targetId?: number
  corrections?: boolean
}

export const SUPPLY_CORRECTION_MIN_PERCENT = -100
export const SUPPLY_CORRECTION_MAX_PERCENT = 100

export interface SupplyCorrection {
  scope: 'category' | 'product'
  targetId: number
  percent: number
}

export interface SupplyCorrectionsResponse {
  corrections: SupplyCorrection[]
}

export interface SupplyCorrectionParams {
  storeId: number
  scope: 'category' | 'product'
  targetId: number
  percent: number
}
